import React, { useState } from "react";
import { Box } from "@mui/material";
import DashboardLayout from "../../layouts/DashboardLayout/DashboardLayout";
import DashboardChartsContainer from "./DashboardChartsContainer/DashboardChartsContainer";
import AlertsTableContainer from "./AlertsTableContainer/AlertsTableContainer";
import AnalyticsWidgets from "../DashboardEquipment/AnalyticsWidgets/AnalyticsWidgets";
import AnalyticsWidgetsPanel from "../DashboardEquipment/AnalyticsWidgets/AnalyticsWidgetsPanel";
import {useSelector} from "react-redux";
import {AxiosHeaders as alertsDateFilters} from "axios";

const DashboardPage = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const siteIdStore = useSelector((state) => state.siteId);
  const storeDateRange = useSelector(state => state.analyticsSelections.dateRange);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <DashboardLayout drawerOpen={drawerOpen} toggleDrawer={toggleDrawer}>
      {/* Main Content */}
      <Box sx={{ gap: "20px", display: "flex", flexDirection: "column" }}>
        <DashboardChartsContainer />
        <AnalyticsWidgetsPanel
          siteId={siteIdStore.siteId}
          dateFrom={storeDateRange.start}
          dateTo={storeDateRange.end}
          equipmentTypeIds={[]}
          maxContainerWidth="100%"
          withDateRange={true}
          mx="none"
        />
        <AlertsTableContainer />
      </Box>
    </DashboardLayout>
  );
};

export default DashboardPage;
